import styled from 'styled-components';
import { media } from 'theme/breakpoints';

export const Header = styled.div`
  position: relative;
  margin-top: 5rem;
  margin-bottom: 1rem;
  text-align: left;

  @media (min-width: 601px) {
    padding: 1rem 1rem 0 1rem;
  }

  @media (max-width: 600px) {
    padding-bottom: 1em;
    border-bottom: 1px solid #eaebec;
  }
`;

export const Title = styled.h1`
  margin: 1rem 0 1rem 0;
  font-weight: 800;
  font-size: 2rem;
  line-height: 1.4;

  ${media.desktopWide} {
    font-size: 1.8rem;
  }

  @media (max-width: 600px) {
    font-size: 1.6rem;
  }

  @media (max-width: 400px) {
    font-size: 1.5rem;
  }
`;

export const ImgCoverContainer = styled.div`
  width: 100%;
  height: auto;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const ContentContainer = styled.article`
  display: block;
  background-color: #fff;
  & a {
    display: inline;
  }
  p {
    margin-bottom: 1.25rem;
    line-height: 1.8;
    font-size: 20px;
  }
`;

export const ArticleFooter = styled.section`
  border-top: 1px solid #eaebec;
  border-bottom: 1px solid #eaebec;
  padding-top: 3rem;
  padding-bottom: 3rem;
  & .bio {
    font-size: 16px;
    line-height: 28px;
    margin-top: 16px;
  }
  .profile-picture {
    margin: 0 auto;
  }
`;

export const TimeToRead = styled.em`
  font-style: normal;
  margin-left: 16px;
  position: relative;
  &::before {
    content: '';
    width: 4px;
    height: 4px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-10px, -25%);
    border-radius: 50%;
    background-color: #000;
    opacity: 0.75;
  }
`;
